module.exports = ":host .mat-tab-body-wrapper {\n  flex: 1 0 auto; }\n\n.mat-tab-body-wrapper {\n  flex: 1 0 auto; }\n"